"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var AnimationObject_1 = require("../AnimationObject");
var ShapeElementType;
(function (ShapeElementType) {
    ShapeElementType["Group"] = "gr";
    ShapeElementType["Fill"] = "fl";
})(ShapeElementType = exports.ShapeElementType || (exports.ShapeElementType = {}));
var ShapeElement = (function (_super) {
    tslib_1.__extends(ShapeElement, _super);
    function ShapeElement(rawData, version) {
        return _super.call(this, rawData, version) || this;
    }
    Object.defineProperty(ShapeElement.prototype, "hidden", {
        get: function () {
            return this._rawData.hd;
        },
        set: function (hidden) {
            this._rawData.hd = hidden;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShapeElement.prototype, "name", {
        get: function () {
            return this._rawData.nm;
        },
        set: function (name) {
            this._rawData.nm = name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShapeElement.prototype, "type", {
        get: function () {
            return this._rawData.ty;
        },
        set: function (type) {
            this._rawData.ty = type;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShapeElement.prototype, "index", {
        get: function () {
            return this._rawData.ix;
        },
        set: function (index) {
            this._rawData.ix = index;
        },
        enumerable: true,
        configurable: true
    });
    return ShapeElement;
}(AnimationObject_1.AnimationObject));
exports.ShapeElement = ShapeElement;
//# sourceMappingURL=ShapeElement.js.map